import { isApiErrors } from '../../../models/ApiErrors'

const CROSS_CLIENT_FUNDS_QUOTA_PREFIX = 'ai:ccq'

export const CROSS_CLIENT_FUNDS_START_BLOCKED_MESSAGE = 'Not enough credits to start a new query.'
export const CROSS_CLIENT_AI_EVAL_BLOCKED_MESSAGE = 'Not enough credits to run AI analysis.'
export const CROSS_CLIENT_FUNDS_TOAST_MESSAGE = "You don't have enough credits to continue."

export const isCrossClientFundsQuotaError = (error: unknown): boolean => {
  if (typeof error !== 'object' || error === null) {
    return false
  }
  if (!('status' in error) || error.status !== 400) {
    return false
  }
  if (!('data' in error) || !isApiErrors(error.data)) {
    return false
  }
  return error.data.errors.some((apiError) => apiError.location?.startsWith(CROSS_CLIENT_FUNDS_QUOTA_PREFIX) ?? false)
}
